import { createI18n } from 'vue-i18n'
import fr from '@/locales/fr.json'
import en from '@/locales/en.json'
import de from '@/locales/de.json'
import es from '@/locales/es.json'
import { type Path } from '@intlify/core-base'
import { PrefixTranslationsEnum } from '@/common/types/i18n'

// https://vue-i18n.intlify.dev/guide/essentials/syntax#special-characters
const specialCharactersMap = {
  '{': "{'{'}",
  '@': "{'@'}",
  '}': "{'}'}",
  ['$']: "{'$'}",
  '|': "{'|'}",
}

const convertSpecialCharacterToTemplateLiteral = (message: string) => {
  return message.replace(/[{@}$|]/g, (match) => {
    return specialCharactersMap[match as keyof typeof specialCharactersMap]
  })
}

const messageResolver = (obj: unknown, path: Path) => {
  if (typeof obj !== 'object') return null
  if (!obj || path in obj === false) return null

  const message = (obj as Record<string, string>)[path]
  if (!message) return null

  if (path.startsWith(PrefixTranslationsEnum.ASSIST)) {
    return message
  } else {
    return convertSpecialCharacterToTemplateLiteral(message)
  }
}

const i18n = createI18n({
  legacy: false,
  messages: {
    en: en,
    fr: fr,
    de: de,
    es: es,
  },
  messageResolver,
  silentTranslationWarn: true,
  silentFallbackWarn: true,
})

export default i18n
